/* unplugin-vue-components disabled */import { render } from "./hysbwg.vue?vue&type=template&id=dd8a0a0a"
import script from "./hysbwg.vue?vue&type=script&lang=js"
export * from "./hysbwg.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__